import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useApi } from '@/hooks/useAppApi'

export interface PrincipalResults {
  users: Array<{ id: string; name: string; email: string }>
  teams: Array<{ id: string; name: string; memberCount: number }>
}

/**
 * Tenant-scoped principal (user/team) typeahead search — backs PrincipalPicker.
 * Disabled below a 2-char query so short/empty input never fires a request
 * (matches the backend's own short-circuit in GET /collaboration/principals).
 */
export function usePrincipals(q: string): UseQueryResult<PrincipalResults> {
  const api = useApi()
  return useQuery<PrincipalResults>({
    queryKey: ['principals', q],
    queryFn: (): Promise<PrincipalResults> =>
      api.get<PrincipalResults>(`/collaboration/principals?q=${encodeURIComponent(q)}`),
    enabled: q.trim().length >= 2,
  })
}
